import React from 'react';
import PropTypes from 'prop-types';
import convertEntities from './../utils/convertEntities';
var Chip = function Chip(_ref) {
  var value = _ref.value,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "cg__chip"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cg__chip__text",
    dangerouslySetInnerHTML: {
      __html: value
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "cg__chip__close",
    onClick: onClick
  }));
};
Chip.propTypes = {
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};
export default Chip;